'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoModelS = function IoModelS(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm39.8 30.5v1c0 0.2-0.1 0.4-0.1 0.5-0.1 1-0.2 1.4-0.5 1.6-0.2 0.2-0.5 0.2-0.8 0.2h-3.3s-0.8-0.1-0.9-1.3v-0.6c1.6-0.1 3.1-0.1 4.1 0 0.8 0 1 0 1.2-0.5 0.2-0.2 0.2-0.5 0.3-0.9z m-39.6 0c0.1 0.4 0.1 0.7 0.3 0.9 0.2 0.5 0.4 0.5 1.2 0.5 1-0.1 2.5-0.1 4.1 0v0.6c-0.1 1.2-0.6 1.3-0.9 1.3h-3.3s-0.6 0-0.8-0.2c-0.3-0.2-0.5-0.6-0.6-1.6v-1.5z m39.8-7.3c0 2.4-0.2 4.5-0.2 5.3 0 0.3 0 0.9 0 1.4-0.1 0.3-0.1 0.6-0.3 0.9-0.2 0.4-0.4 0.4-1.2 0.4-1 0-2.5 0-4.1 0-1 0-2.1 0.2-3 0.2-2.4 0.1-1.7-0.3-2.7-0.3s-4.9 0.1-8.5 0.1-7.6-0.1-8.6-0.1-0.3 0.4-2.7 0.3c-0.9 0-1.9-0.2-2.9-0.2-1.6 0-3.1 0-4.1 0-0.8 0-1 0-1.2-0.4-0.2-0.3-0.2-0.6-0.3-0.9 0-0.5 0-1.1 0-1.4 0-0.8-0.2-2.9-0.2-5.3s0.3-4.8 0.5-5c0-0.2 0.6-0.7 2-1.6s1.3-0.8 1.6-1.4c-0.3-0.1-0.4-0.3-0.6-0.3-0.3 0-0.3 0.3-0.9 0.3s-1.9-0.1-2.2-0.4c-0.3-0.3-0.4-0.4-0.4-0.7s0.2-0.7 0.4-1 1.5-0.4 2.1-0.5 0.8 0 0.9 0.1c0.4 0.1 0.3 1.7 0.3 1.7l0.7 0.1c0.4-1.1 0.9-3.3 1.9-4.9 1-1.8 2-2.3 2.5-2.5s0.7-0.1 3.7-0.5 5.4-0.4 7.5-0.4 4.5 0.1 7.5 0.4 3.3 0.4 3.8 0.5 1.4 0.7 2.5 2.5c0.9 1.6 1.4 3.8 1.8 4.9l0.7-0.1s-0.1-1.6 0.3-1.7c0.1-0.1 0.3-0.2 0.9-0.1s1.9 0.2 2.1 0.5 0.4 0.8 0.4 1-0.1 0.4-0.4 0.7-1.6 0.4-2.2 0.4-0.6-0.3-0.9-0.3c-0.2 0-0.3 0.2-0.6 0.3 0.3 0.6 0.2 0.4 1.6 1.4s2 1.4 2 1.6c0.2 0.2 0.5 2.6 0.5 5z m-33.3-11.9c-0.4 0.9-0.8 2.6-0.8 2.8s0 0.4 1.2 0.4 9.2-0.3 12.9-0.3 11.6 0.2 12.9 0.3 1.1-0.1 1.2-0.4-0.4-1.9-0.8-2.8-1.3-2.4-2-2.9c-0.2 0-1.4-0.5-4.3-0.7-2.6-0.1-5.6-0.2-7-0.2s-4.4 0.1-7 0.2c-2.9 0.2-4.1 0.7-4.2 0.7-0.6 0.4-1.7 2.1-2.1 2.9z m2.9 9.8c0.6-0.2 0.9-0.2 0.9-0.2s-1.4-1.2-3.8-1.9-3.8-0.9-5.1-0.8c0 0-0.3 1.3 0 2.1s0.6 0.8 1.2 1 1 0.3 1.3 0.3 0.5-0.3 0.9-0.3 2.3 0.3 3 0.3 1.1-0.3 1.6-0.5z m18.4 6.2c1.1-0.2 2.6-1.5 1.6-2.6-1.4-1.5-1.2-1.5-4.3-1.9-2.7-0.3-4.8-0.3-5.3-0.3s-2.6 0-5.3 0.3c-3.1 0.4-2.9 0.4-4.3 1.9-1 1.1 0.5 2.4 1.6 2.6 1.1 0.1 5.8 0.2 8 0.2s6.9-0.1 8-0.2z m10.4-7c0.3-0.8 0-2.1 0-2.1-1.3-0.1-2.7 0.1-5.1 0.8s-3.8 2-3.8 2 0.3-0.1 0.9 0.1 0.9 0.5 1.6 0.5 2.6-0.3 3-0.3 0.7 0.2 0.9 0.3 0.7-0.2 1.3-0.3 1-0.1 1.2-1z' })
        )
    );
};

exports.default = IoModelS;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/model-s.js
// module id = 2839
// module chunks = 168707334958949